import React from 'react'
import graph from './graph.jpg'
import {handle} from '../events'
import {Rect} from 'react-konva'
import * as Behaviours from 'alcumus-behaviours'
import interpolate from 'color-interpolate'

import useImage from 'use-image'
import {addGameObject, createGameObject} from '../system'
import {getState} from '../game-surface'
import {SPACE} from '../clouds'

function Sprite(sprite, owner) {
    let result = function Sprite() {
        let [image] = useImage(sprite)
        return (
            <>
                {(image && (
                    <Rect
                        x={0}
                        y={0}
                        fillPatternOffsetY={owner.patternY || 0}
                        fillPatternImage={image}
                        fillPatternRepeat="repeat"
                        width={2048}
                        height={2048}
                        image={image}
                    />
                )) ||
                    null}
            </>
        )
    }

    return result
}


const sky = interpolate(['skyblue', 'purple', 'darkblue', 'black'])

function Sky() {

    return <Rect x={0} y={0} fill={sky(-this.patternY/SPACE)} width={2048} height={2048} />
}

Behaviours.register('background', {
    initialize() {
        this.patternY = this.patternY || 0
        this.document.speed = this.document.speed || 100
        handle('resetGame', () => {
            this.patternY = 0
        })
        handle('startGame', () => {
            this.patternY = 0
        })
    },

    postInitialize() {
        this.document.addChild(
            createGameObject(
                { opacity: 1 },
                {
                    sprite: { Sprite: Sky.bind(this) },
                }
            ),
            createGameObject(
                { opacity: 0.5 },
                {
                    sprite: { Sprite: Sprite(graph, this) },
                }
            ),

        )
    },
    methods: {
        update(dt) {

            this.patternY -= this.document.speed * dt * getState().rocketSpeed
            getState().height = getState().speed > 0.1 ? -this.patternY : getState().height
        },
    },
})

handle('initializeGame', () => {
    addGameObject(
        { x: 0, y: 0, scale: 1, z: -100, speed: 350 },
        {
            background: {},
        }
    )
})
